export class QuestionnaireResponse {
  constructor(
    public answer: number,
    public question: number,
    public time_taken_to_complete: number,
  ) {}
}
